import vp from './vp'
import vt from './vt'
import enterprise from './enterprise'
import teams from './teams'
import shared from './shared'

const navigation = {
  vp,
  vt,
  enterprise,
  teams,
  shared
}

export default navigation;
